import React from 'react';
import {
  Grid,
  Typography,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { SIGNALS, inputSx, selectSx, TV } from '../../constants';

const TimeBoundDetails = ({ sub, idx, onUpdate, bulkStrategyTimeframe }) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <Typography sx={{ fontSize: '11px', color: TV.accent.primary, fontWeight: 600, mb: 1.5, textTransform: 'uppercase' }}>
        Early Signal
      </Typography>
    </Grid>
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth size="small">
        <InputLabel>Signal</InputLabel>
        <Select 
          value={sub.condition?.early_signal?.name || ''} 
          label="Signal"
          onChange={(e) => onUpdate(idx, 'condition', { 
            ...sub.condition, 
            early_signal: { name: e.target.value, timeframe: sub.condition?.early_signal?.timeframe || bulkStrategyTimeframe } 
          })} 
          sx={selectSx}
        >
          <MenuItem value="">-- None --</MenuItem>
          {SIGNALS.map(sig => <MenuItem key={sig} value={sig}>{sig}</MenuItem>)}
        </Select>
      </FormControl>
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField 
        fullWidth size="small" 
        label="Timeframe" 
        value={sub.condition?.early_signal?.timeframe || bulkStrategyTimeframe} 
        onChange={(e) => onUpdate(idx, 'condition', { 
          ...sub.condition, 
          early_signal: { name: sub.condition?.early_signal?.name || '', timeframe: e.target.value } 
        })} 
        sx={inputSx} 
      />
    </Grid>

    <Grid item xs={12}><Box sx={{ height: '1px', bgcolor: TV.border.primary }} /></Grid>

    <Grid item xs={12}>
      <Typography sx={{ fontSize: '11px', color: TV.accent.primary, fontWeight: 600, mb: 1.5, textTransform: 'uppercase' }}>
        Confirmation Signal
      </Typography>
    </Grid>
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth size="small">
        <InputLabel>Signal</InputLabel>
        <Select 
          value={sub.condition?.confirmation_signal?.name || ''} 
          label="Signal"
          onChange={(e) => onUpdate(idx, 'condition', { 
            ...sub.condition, 
            confirmation_signal: { name: e.target.value, timeframe: sub.condition?.confirmation_signal?.timeframe || bulkStrategyTimeframe } 
          })} 
          sx={selectSx}
        >
          <MenuItem value="">-- None --</MenuItem>
          {SIGNALS.map(sig => <MenuItem key={sig} value={sig}>{sig}</MenuItem>)}
        </Select>
      </FormControl>
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField 
        fullWidth size="small" 
        label="Timeframe" 
        value={sub.condition?.confirmation_signal?.timeframe || bulkStrategyTimeframe} 
        onChange={(e) => onUpdate(idx, 'condition', { 
          ...sub.condition, 
          confirmation_signal: { name: sub.condition?.confirmation_signal?.name || '', timeframe: e.target.value } 
        })} 
        sx={inputSx} 
      />
    </Grid>

    <Grid item xs={12}><Box sx={{ height: '1px', bgcolor: TV.border.primary }} /></Grid>

    <Grid item xs={12} sm={6}>
      <TextField 
        fullWidth size="small" type="number" 
        label="Min Minutes" 
        value={sub.condition?.min_minutes ?? ''} 
        onChange={(e) => {
          const value = e.target.value === '' ? '' : parseFloat(e.target.value);
          onUpdate(idx, 'condition', { ...sub.condition, min_minutes: value });
        }} 
        sx={inputSx} 
        inputProps={{ min: 0, step: '0.1' }}
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField 
        fullWidth size="small" type="number" 
        label="Max Minutes" 
        value={sub.condition?.max_minutes ?? ''} 
        onChange={(e) => {
          const value = e.target.value === '' ? '' : parseFloat(e.target.value);
          onUpdate(idx, 'condition', { ...sub.condition, max_minutes: value });
        }} 
        sx={inputSx} 
        inputProps={{ min: 0, step: '0.1' }}
      />
    </Grid>
  </Grid>
);

export default TimeBoundDetails;
